import { AlignItems, FilesPreview, FileType, Overflow, SkeletonBox, Spacing } from '@billy/design-system'
import { ReactElement, RefObject, useEffect, useState } from 'react'

import { DEFAULT_ZOOM_LEVEL } from '@features/invoices/constants/defaultZoomLevel'
import { getInvoicingSettingsPreviewZoom } from '@features/invoicingSettings/utils/getInvoicingSettingsPreviewZoom'

import { getClassName } from '../../../../../../../../../utils/getClassName'

interface InvoiceSettingsHtmlPreviewProps {
  htmlFiles: string[] | undefined
  isLoading: boolean
  previewWrapperRef: RefObject<HTMLDivElement>
}

export const InvoiceSettingsHtmlPreview = ({
  htmlFiles = [],
  isLoading,
  previewWrapperRef,
}: InvoiceSettingsHtmlPreviewProps): ReactElement => {
  const [currentZoom, setCurrentZoom] = useState(DEFAULT_ZOOM_LEVEL)

  const previewFiles = htmlFiles.map((file) => ({ src: file }))

  const filesPreviewKey = previewFiles.map((file) => file.src).join(',')

  useEffect(() => {
    if (previewWrapperRef.current) {
      const wrapperWidth = previewWrapperRef.current.offsetWidth
      const initialZoom = getInvoicingSettingsPreviewZoom(wrapperWidth)

      setCurrentZoom(initialZoom)
    }
  }, [previewWrapperRef])

  if (previewFiles.length === 0 || isLoading) {
    return <SkeletonBox fullHeight fullWidth />
  }

  return (
    <FilesPreview
      alignment={AlignItems.SafeCenter}
      asType={FileType.Html}
      className={getClassName('dark-theme-suspend')}
      files={previewFiles}
      fitToWidth
      fullWidth={false}
      key={filesPreviewKey}
      margin={Spacing.S16}
      withPagination={false}
      wrapperOverflowY={Overflow.Auto}
      zoomScale={currentZoom}
    />
  )
}
